export default __webpack_public_path__ + "static/media/img-0117-france-full-face.5f773188.png";